import React, {Component} from "react";

class ResultClassSummary extends Component {

    renderSummaryCellWidget = (label, value, border=true) => {
        return (
            <div className="class-result-summary-stat-cell" style={{
                height: "100%",
                width: "calc(100% / 9)",
                minWidth: 0,
                display: "grid",
                gridTemplateRows: "auto 1px auto",
                borderLeft: border ? "1px solid rgb(193, 193, 193)" : "",
                textAlign: "center",
                overflow: "hidden",
            }}>
                <div style={{
                    display: "flex",
                    placeItems: "center center",
                    minHeight: 0,
                    overflow: "hidden",
                    padding: "0 2px",
                }}>
                    <p style={{width: "100%", color: "var(--blue)", margin: 0, fontSize: "11px", lineHeight: 1.2, wordBreak: "break-word"}}>{label}</p>
                </div>

                <hr style={{
                    border: "none",
                    background: "#c1c1c1",
                    height: "1px",
                }}/>

                <div style={{
                    display: "flex",
                    placeItems: "center right"
                }}>
                    <p style={{width: "100%"}} contentEditable={"true"}>{value}</p>
                </div>
            </div>
        )
    }


    render() {
        const {class_info} = this.props;

        return (
            <div
                style={{
                    border: "1px solid rgb(193, 193, 193)",
                    textAlign: "center",
                    borderRadius: "5px",
                    backgroundColor: "white",
                }}>
                <div style={{
                    display: "flex",
                    placeItems: "center center",
                    height: "35px",
                }}>
                    <p style={{width: "100%", color: "var(--blue)"}}>خلص نتایج</p>
                </div>

                <hr style={{
                    border: "none",
                    background: "#c1c1c1",
                    height: "1px",
                }}/>

                <div className="class-result-summary-stats-row" style={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    placeItems: "center center",
                    height: "70px",
                    minWidth: 0,
                    overflow: "hidden",
                }}>

                    {this.renderSummaryCellWidget('تعداد داخله', class_info?.total_count)}
                    {this.renderSummaryCellWidget('شامل امتحان', class_info?.total_allowed)}
                    {this.renderSummaryCellWidget('کامیاب', class_info?.total_passed)}
                    {this.renderSummaryCellWidget('اخطاریه', class_info?.total_warnings)}
                    {this.renderSummaryCellWidget('ناتکمیل ', class_info?.total_unfinished)}
                    {this.renderSummaryCellWidget('شمولیت مجدد', class_info?.total_rejoined)}
                    {this.renderSummaryCellWidget('ناکام ', class_info?.total_failed)}
                    {this.renderSummaryCellWidget('محروم', class_info?.total_deprived)}
                    {this.renderSummaryCellWidget('تبدیلی ', class_info?.total_swapped, false)}

                </div>
            </div>
        );
    }
}

export default ResultClassSummary;
